// Item ativo do submenu da Sidebar (função pura, testável sem React).

// Telas de detalhe do WhatsApp que não têm item próprio no menu: acendem o item pai (Anexo C §1.2 e rotas do
// plano-front §4). Subrotas de um item já acendem por prefixo: /whatsapp/disparos cobre /novo, /:id e /:id/editar;
// /whatsapp/fluxos cobre /:id/execucoes (e o editor em tela cheia, que nem mostra a sidebar).
export const MENU_ROUTE_ALIASES: Readonly<Record<string, readonly string[]>> = {
    '/whatsapp': ['/whatsapp/alertas'],
    '/whatsapp/numeros': ['/whatsapp/pools'],
    '/whatsapp/grupos': ['/whatsapp/conjuntos', '/whatsapp/comunidades'],
    '/whatsapp/contatos': ['/whatsapp/listas', '/whatsapp/segmentos', '/whatsapp/importacoes'],
    '/whatsapp/configuracoes': ['/whatsapp/campos', '/whatsapp/webhooks', '/whatsapp/templates', '/whatsapp/servidores'],
};

const under = (pathname: string, route: string) => pathname === route || pathname.startsWith(route + '/');

// Ativo: a rota atual é a do item, está abaixo dela ou abaixo de um alias dela. Um item que é o
// "índice" do grupo (rota prefixo das irmãs, ex.: /whatsapp → Visão geral) só fica ativo na rota
// exata, senão acenderia junto com todas as telas do módulo.
export function isMenuChildActive(route: string | null | undefined, siblingRoutes: Array<string | null | undefined>, pathname: string): boolean {
    if (!route) return false;
    if (pathname === route) return true;
    if ((MENU_ROUTE_ALIASES[route] ?? []).some((alias) => under(pathname, alias))) return true;
    const isIndex = siblingRoutes.some((s) => !!s && s !== route && s.startsWith(route + '/'));
    return !isIndex && pathname.startsWith(route + '/');
}
